import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';

export const getDefaultCondition = (id, fieldsList) => {
    return fieldsList[id].default;
}

export const getTemplateName = (activeMenu) => {
    return (activeMenu === 'jkit-header' || activeMenu === 'jkit-footer') ? activeMenu : 'jkit-template'
}

export const createTemplate = (params) => {

    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/createTemplate',
            method: 'POST',
            data: {
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const cloneTemplate = (params) => {

    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/cloneTemplate',
            method: 'POST',
            data: {
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const deleteTemplate = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/deleteTemplate',
            method: 'POST',
            data: {
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export const updateTemplate = (params) => {

    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/updateTemplate',
            method: 'POST',
            data: {
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export const updatePriority = (params) => {

    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/updatePriority',
            method: 'POST',
            data: {
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}



export const updateTemplateStatus = (params) => {

    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/updateTemplateStatus',
            method: 'POST',
            data: {
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}




export const searchPostsOrPage = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchPostsOrPages',
            method: 'POST',
            data: {
                post_type: 'post',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const searchPages = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchPostsOrPages',
            method: 'POST',
            data: {
                post_type: 'page',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const searchProducts = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchPostsOrPages',
            method: 'POST',
            data: {
                post_type: 'product',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}



export const searchTaxonomies = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchTaxonomies',
            method: 'POST',
            data: {
                post_type: 'post',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const searchCategories = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchTaxonomiesByTitleAndId',
            method: 'POST',
            data: {
                taxonomy: 'category',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const searchTags = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchTaxonomiesByTitleAndId',
            method: 'POST',
            data: {
                taxonomy: 'post_tag',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export const searchProductCategories = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchTaxonomiesByTitleAndId',
            method: 'POST',
            data: {
                taxonomy: 'product_cat',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const searchProductTags = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchTaxonomiesByTitleAndId',
            method: 'POST',
            data: {
                taxonomy: 'product_tag',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}



export const searchPosts = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchPostsByTitleAndId',
            method: 'POST',
            data: {
                post_type: 'post',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}



export const searchAuthors = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/searchAuthors',
            method: 'POST',
            data: {
                post_type: 'post',
                ...params,
            },
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}



export const getTemplateLists = (type) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: `/jkit/v1/getTemplateLists?type=${type}`,
            method: 'GET'
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const getPost = (id) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: `/jkit/v1/getTemplateConditions?id=${id}`,
            method: 'GET'
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};
